import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.mata = bracketIndenting()
